module.exports = __webpack_public_path__ + "img/end_ligth.368ba5e3.png";